import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import HistorySidebar from './history/HistorySidebar';
import VersionChanges from './history/VersionChanges';
import { useRightPanel } from '../app/layout/RightPanel';
import { gql } from '../graphql/generated/gql';
import useNavigate from '../utils/router/useNavigate';
import useSlug from '../utils/router/useSlug';
import historyPath from '../utils/url/historyPath';

const POST_HISTORY_REDIRECT_QUERY = gql(/** @complexity 3 */ `
  query PostHistoryRedirect($id: ID!) {
    post(id: $id) {
      id
      title
      content(isLatest: true) {
        id
        version
      }
      lastHistory {
        id
        versionFrom
        versionTo
      }
      ...historyPath_post
    }
  }
`);

const PostHistoryRedirectView = () => {
  const [postId] = useSlug('postSlug');
  const navigate = useNavigate();

  const { openRightPanel } = useRightPanel();

  const { data } = useQuery(POST_HISTORY_REDIRECT_QUERY, {
    variables: { id: postId },
    fetchPolicy: 'no-cache',
  });

  const post = data?.post ?? null;

  useEffect(() => {
    openRightPanel(<HistorySidebar postId={postId} tab="versions" />);

    if (!post) {
      return undefined;
    }

    const {
      lastHistory,
      content: { version },
    } = post;
    let from;
    let to;
    const latestVersion = lastHistory?.versionTo ?? 0;
    if (latestVersion < version) {
      from = latestVersion;
      to = version;
    } else if (lastHistory) {
      from = lastHistory.versionFrom;
      to = lastHistory.versionTo;
    } else {
      return undefined;
    }

    navigate(historyPath(post, from, to), { replace: true });
    return undefined;
  }, [post, postId, navigate, openRightPanel]);

  return (
    <VersionChanges.Wrapper
      postTitle={post?.title}
      initialTitle="History - Slab"
    />
  );
};

export default PostHistoryRedirectView;
